import useFantasySelected from '@/DesignSystem/hooks/useFantasySelected';
import { Box, Typography } from '@mui/material';
import { FANTASY } from '@/helpers/biwenger-helper';

export const getBackgroundColorForPuntuacionFantasy = (
    estadisticaPartido,
    confirmedMode,
    confirmedFantasy
) => {
    if (!estadisticaPartido) return '#ccc';

    const puntuacion = parseFloat(estadisticaPartido);

    const mode = confirmedMode ?? confirmedFantasy;

    // Rangos para La Liga Fantasy
    if (mode === FANTASY.FANTASY) {
        if (puntuacion < 3) return '#d32f2f'; // Rojo
        if (puntuacion >= 3 && puntuacion <= 4) return '#ed6c02'; // Naranja
        if (puntuacion >= 5 && puntuacion <= 6) return '#2e7d32'; // Verde oscuro
        if (puntuacion >= 7 && puntuacion <= 8) return '#01aa4d'; // Verde claro
        if (puntuacion > 8) return '#1D6FB1'; // Azul
    }

    if (mode === FANTASY.FANTASY_MARCA) {
        if (puntuacion < 3) return '#d32f2f'; // Rojo
        if (puntuacion >= 3 && puntuacion <= 4) return '#ed6c02'; // Naranja
        if (puntuacion >= 5 && puntuacion <= 6) return '#2e7d32'; // Verde oscuro
        if (puntuacion >= 7 && puntuacion <= 8) return '#01aa4d'; // Verde claro
        if (puntuacion > 8) return '#1D6FB1'; // Azul
    }

    if (mode === FANTASY.MISTER_FANTASY) {
        if (puntuacion < 3) return '#d32f2f'; // Rojo
        if (puntuacion >= 3 && puntuacion <= 4) return '#ed6c02'; // Naranja
        if (puntuacion >= 5 && puntuacion <= 6) return '#2e7d32'; // Verde oscuro
        if (puntuacion >= 7 && puntuacion <= 8) return '#01aa4d'; // Verde claro
        if (puntuacion > 8) return '#1D6FB1'; // Azul
    }

    // Rangos para Biwenger
    if (mode === FANTASY.BIWENGER) {
        if (puntuacion < 3) return '#d32f2f'; // Rojo
        if (puntuacion >= 3 && puntuacion <= 4) return '#ed6c02'; // Naranja
        if (puntuacion >= 5 && puntuacion <= 6) return '#2e7d32'; // Verde oscuro
        if (puntuacion >= 7 && puntuacion <= 8) return '#01aa4d'; // Verde claro
        if (puntuacion > 8) return '#1D6FB1'; // Azul
    }

    // Rangos para Analítica Fantasy
    if (mode === FANTASY.ANALITICA) {
        if (puntuacion < 6) return '#d32f2f'; // Rojo
        if (puntuacion >= 6 && puntuacion < 6.5) return '#ed6c02'; // Naranja
        if (puntuacion >= 6.5 && puntuacion < 7) return '#2e7d32'; // Verde oscuro
        if (puntuacion >= 7 && puntuacion < 7.5) return '#01aa4d'; // Verde claro
        if (puntuacion >= 7.5) return '#1D6FB1'; // Azul
    }

    // Rangos por defecto (fallback)
    if (puntuacion >= 8) return '#1D6FB1'; // Azul
    if (puntuacion >= 7) return '#01aa4d'; // Verde claro
    if (puntuacion >= 6) return '#2e7d32'; // Verde oscuro
    if (puntuacion >= 5) return '#ed6c02'; // Naranja
    return '#d32f2f'; // Rojo
};

const PuntuacionConfirmada = ({
    estadisticaPartido,
    fontSize = 10,
    width = '25px',
    height = '15px',
    display = 'flex',
    justifyContent = 'center',
    alignItems = 'center',
    confirmedMode,
    ...props
}) => {
    const { confirmedFantasy } = useFantasySelected();

    if (!estadisticaPartido) return null;

    return (
        <Box
            {...props}
            bgcolor={getBackgroundColorForPuntuacionFantasy(
                estadisticaPartido,
                confirmedMode,
                confirmedFantasy
            )}
            display={display}
            justifyContent={justifyContent}
            alignItems={alignItems}
            width={width}
            height={height}
            border={`1px solid rgba(255, 255, 255, 0.3)`}
            borderRadius={0.5}
        >
            <Typography fontSize={fontSize} color={'#fff'}>
                {estadisticaPartido}
            </Typography>
        </Box>
    );
};

export default PuntuacionConfirmada;
